import {createTheme} from "@mui/material/styles";
import {PaletteColor} from "@mui/material";

declare module "@mui/material/styles" {
    interface Palette {
        darkGreen: PaletteColor;
        purple: PaletteColor;
        violet: PaletteColor;
        neutral: PaletteColor;
    }
    interface PaletteOptions {
        darkGreen?: PaletteColor;
        purple?: PaletteColor;
        violet?: PaletteColor;
        neutral?: PaletteColor;
    }
    interface Theme {
        custom: {
            // Gradient of colors used to represent SRS stages 0-9 (e.g. ColoredWordListView)
            srsLevelColors: string[];
            // Colors mandated by Google's "Sign in with Google" branding guidelines
            googleButton: {
                text: string;
                border: string;
                background: string;
                hoverBackground: string;
            };
        };
    }
    interface ThemeOptions {
        custom?: {
            srsLevelColors?: string[];
            googleButton?: {
                text?: string;
                border?: string;
                background?: string;
                hoverBackground?: string;
            };
        };
    }
}

export let theme = createTheme({
    palette: {
        background: {default: '#fafafa'},
        primary:   {main:  '#8ecae6', },
        secondary: {main:  '#219ebc', },
        info:      {main:  '#46237A', },
        warning: {main: '#ffb703'},
        success: {main: '#3DDC97'},
        error: {main: '#FF495C'},
    },
    typography: {
        fontFamily: '"Roboto"',
    }
});

theme = createTheme(theme, {
    // Custom colors created with augmentColor go here
    palette: {
        violet: theme.palette.augmentColor({
            color: {
                main: '#e7c6ff',
            },
            name: 'violet',
        }),
        purple: theme.palette.augmentColor({
            color: {
                main: '#5D3FD3'
            },
            name: 'purple'
        }),
        darkGreen: theme.palette.augmentColor({
            color: {
                main: '#006400'
            },
            name: 'darkGreen'
        }),
        neutral: theme.palette.augmentColor({
            color: {
                main: '#e2e3e5'
            },
            name: 'neutral'
        })
    },
    custom: {
        srsLevelColors: [
            '#DDDDDD',
            '#bbdefb',
            '#90caf9',
            '#80deea',
            '#a5d6a7',
            '#c5e1a5',
            '#e6ee9c',
            '#fff59d',
            '#ffe082',
            '#ffcc80',
        ],
        googleButton: {
            text: '#3c4043',
            border: '#dadce0',
            background: '#fff',
            hoverBackground: '#f7f8f8',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                        borderColor: "red",
                    },
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    "&.Mui-error": {
                        color: "red",
                    },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    "&.Mui-error": {
                        color: "red",
                    },
                },
            },
        },
    },
});